import React, { useState } from "react";

const UserFilters = ({ onSearch }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const handleInputChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
  };
  const handleRoleChange = (e) => {
    const value = e.target.value;
    setRole(value);
  };

  const handleSearchClick = () => {
    onSearch({ name, email, role, from, to });
  };
  const handleDateFromChange = (e) => {
    const value = e.target.value;
    setFrom(value);
  };
  const handleDateToChange = (e) => {
    const value = e.target.value;
    setTo(value);
  };

  return (
    <div className=" mb-3 p-3 bg-body rounded shadow-sm">
      <div className="row user-filter-row">
        <div class="d-flex flex-wrap gap-3 search-boxes">
          <div className="col-sm-6">
            <input
              type="text"
              placeholder="Search by Name"
              className="form-control floating"
              value={name}
              onChange={handleInputChange}
              width={200}
            />
          </div>
          <div className="col-sm-6">
            <input
              type="text"
              placeholder="Search by Email"
              className="form-control floating"
              value={email}
              onChange={handleEmailChange}
              width={200}
            />
          </div>
          <div className="col-sm-6">
            <select
              className="form-control"
              value={role}
              onChange={handleRoleChange}
              width={150}
            >
              <option value="">Select Role</option>
              <option value="broker">Broker</option>
              <option value="user">User</option>
            </select>
          </div>
        </div>
        <div class="d-flex gap-3 flex-wrap">
          <div>
            <label>From Date:</label>
            <input
              type="date"
              className="form-control"
              value={from}
              onChange={handleDateFromChange}
              style={{ width: 200 }}
            />
          </div>
          <div>
            <label>To Date:</label>
            <input
              type="date"
              className="form-control"
              value={to}
              onChange={handleDateToChange}
              style={{ width: 200 }}
            />
          </div>
        </div>
        <div className="col-sm-3 col-md-2">
          <button className="btn btn-primary" onClick={handleSearchClick}>
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserFilters;
